import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { SpinnerService } from '@services/spinner.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import notify from 'devextreme/ui/notify';
import { IDokumentViewModel } from '@shared/dokumente/dokument.model';

interface IMappeBez {
    bezeichnung: string;
    hash: string;
}

@Component({
    selector: 'cz-mappe-bezPopup',
    templateUrl: './mappe-bezPopup.component.html',
    styleUrls: ['./mappe-bezPopup.component.css'],
    standalone: false
})
export class MappeBezeichnungPopupComponent {

    @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
    @Output() onOkClose: EventEmitter<any> = new EventEmitter<any>();
    @Input() popupVisible: boolean;
    @Input() selectedMappe: IDokumentViewModel;

    context: IMappeBez = {} as IMappeBez;


    @ViewChild('form', { static: false }) form: DxFormComponent;

    constructor(private spinnerService: SpinnerService, private ajaxService: AjaxService) {
        this.onClickUebernehmen = this.onClickUebernehmen.bind(this);
        this.onClickClose = this.onClickClose.bind(this);
    }

    onClickUebernehmen() {
        if (this.validation()) {

            this.selectedMappe.bezeichnung = this.context.bezeichnung;

            this.ajaxService.post('api/Dokument/SetMappeBezeichnung', this.context).subscribe(response => {
                this.onOkClose.emit(true);
                this.popupVisible = false;
            });
        }
    }

    onClickClose() {
        this.popupVisible = false;
    }

    validation(withMsg: boolean = true) {
        const validationResult = this.form.instance.validate();

        if (!validationResult.isValid) {
            if (withMsg) {
                let msg = '';
                for (const err of validationResult.brokenRules) {
                    msg += err.message + '\r\n';
                }

                notify({
                    message: msg,
                    width: 600
                }, 'error', 3000);
            }

            return false;
        }
        else {
            return true;
        }
    }


    onShowingPopup(event: any) {
        this.context = {
            hash: this.selectedMappe.docHash,
            bezeichnung: this.selectedMappe.bezeichnung
        };
    }

    onHiddenPopup(event: any) {
        this.context = null;
        this.selectedMappe = null;
        this.onClose.emit(null);
    }

    private startLoading() {
        this.spinnerService.show();
    }

    private stopLoading() {
        this.spinnerService.hide();
    }
}
